import api from './client'
import netapi from './netClient'
import { postParams } from '../lib/useParams'

export const getRequestList = async (prm) => {
  // return api.get('support/getRequestList', { params: { P_REQUEST: getParams(prm) } })
  return api.post('support/getRequestList', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}

export const addSupportRequest = async (prm) => {
  return api
    .post('support/addSupportRequest', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
export const addRequestDetail = async (prm) => {
  return api
    .post('support/addRequestDetail', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
export const getSupportRequestDetails = async (prm) => {
  // return api.get('support/getSupportRequestDetails', { params: { P_REQUEST: getParams(prm) } })
  return api.post('support/getSupportRequestDetails', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(result => {
    return result
  })
}
export const closeSupportRequest = async (prm) => {
  return api
    .post('support/closeSupportRequest', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
export const pendingSupportReqCount = async (prm) => {
    return netapi
    .post('support/pendingSupportReqCount', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
/*
export const pendingSupportReqCount = async (prm) => {
  return api
    .post('support/pendingSupportReqCount', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}*/
export const getHelpDocument = async (prm) => {
  return api
    .post('support/getHelpDocument', postParams(prm), { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}
export const addHelpDocument = async (prm,tr_content,en_content) => {
  const pParams =  postParams(prm);
  pParams.append('P_TR_CONTENT', tr_content);
  pParams.append('P_EN_CONTENT', en_content);
  return api
    .post('support/addHelpDocument',pParams, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
    .then((result) => {
      return result.data
    })
}